import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Token from './Token';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <Token path="token/*" />
    </Router>
  </Container>
);
